import _ from "lodash";
import { useQuery } from "@apollo/client";
import { getTranscriptV3BulkUploadTransactionQuery } from "../modules/BulkUploadQueries";
import { PAGE_SIZE } from "../modules/BulkUploadConstants";
import { useCallback } from "react";

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

const useUploadSummary = ({ transactionId, operationType }) => {
  const { data = EMPTY_OBJECT, networkStatus, fetchMore } = useQuery(
    getTranscriptV3BulkUploadTransactionQuery,
    {
      fetchPolicy: "cache-first",
      variables: {
        id: transactionId,
        filters: {
          operationType,
          first: PAGE_SIZE,
        },
      },
      notifyOnNetworkStatusChange: true,
      skip: _.isNil(operationType),
    }
  );

  const node = _.get(data, "node", EMPTY_OBJECT);
  const payload = _.get(node, "payload", EMPTY_OBJECT);
  const headers = _.get(payload, "headers", EMPTY_ARRAY);
  const summaryRows = _.get(node, "summaryRows", EMPTY_OBJECT);
  const totalCount = _.get(summaryRows, "totalCount", 0);
  const hasNextPage = _.get(summaryRows, "pageInfo.hasNextPage", false);
  const endCursor = _.get(summaryRows, "pageInfo.endCursor", "");
  const edges = _.get(summaryRows, "edges", EMPTY_ARRAY);

  const loadMoreFeed = useCallback(() => {
    fetchMore({
      variables: {
        id: transactionId,
        filters: {
          operationType,
          first: PAGE_SIZE,
          after: endCursor,
        },
      },
    });
  }, [endCursor, fetchMore, operationType, transactionId]);

  const isFetchingMoreData = networkStatus === 3;
  const isLoading = _.includes([1, 2], networkStatus);

  return {
    edges,
    headers,
    totalCount,
    hasNextPage,
    isFetchingMoreData,
    isLoading,
    loadMoreFeed,
  };
};

export default useUploadSummary;
